<template>
  <div class="page">
    <div class="content-center">
      <!-- 步骤条 -->
      <div class="steps">
        <div class="step-item">
          <div class="step-item-num">1</div>
          <div class="step-item-title">填写信息</div>
        </div>
        <div class="step-item bright">
          <div class="step-item-num">2</div>
          <div class="step-item-title">提交审核</div>
        </div>
        <div class="step-item">
          <div class="step-item-num">3</div>
          <div class="step-item-title">注册成功</div>
        </div>
      </div>
      <div class="content-card">
        <img src="@/assets/img/supplier-signature/auditing.png">
        <div class="title">您的信息审核中...</div>
        <div class="subtitle">我们预计五个工作日完成审核，审核结果通过短信的方式通知您</div>
        <div class="primary-btn" @click="goHome">返回首页</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push('/home');
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100vh - @header-height);
  padding-top: 48px;
  .steps {
    height: 74px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    .step-item {
      display: flex;
      align-items: center;
      + .step-item {
        margin-left: 160px;
        position: relative;
        &::before {
          content: '';
          width: 128px;
          height: 1px;
          background-image: linear-gradient(to right, #C4C4C4 0%, #C4C4C4 50%, transparent 50%, transparent 50%);
          background-size: 10px 100%;
          position: absolute;
          left: -16px;
          top: 50%;
          transform: translate(-100%, -50%);
        }
      }
      .step-item-num {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        border-radius: 50%;
        background-color: #EDEFF2;
        color: #979EA5;
        line-height: 24px;
        text-align: center;
      }
      &.bright {
        .step-item-num {
          background-color: @primary-color;
          color: #fff;
        }
        .step-item-title {
          font-family: @font-medium;
          color: @default-color;
        }
      }
    }
  }

  .content-card {
    margin-top: 24px;
    padding: 40px 0 70px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      margin-top: 12px;
      font-family: @font-medium;
      font-size: 20px;
    }
    .subtitle {
      margin-top: 24px;
      font-size: 14px;
      color: #666666;
    }
    .primary-btn {
      width: 185px;
      height: 49px;
      margin-top: 48px;
    }
  }
}
</style>
